import { GetBannersResponse } from '@nxsys/types/api/banner';
import axios from '../axios';
import { endPoints } from '../endpoints';

export const getBannersApi = async (): Promise<GetBannersResponse> => {
  const response = await axios.get(endPoints.banner.main);
  return response.data;
};
